import { AudienceGender } from "app/pages/sales-intelligence/domain/leads/types/enums";
import { FilterPanelBaseFilter } from "app/pages/sales-intelligence/modules/advanced-search-filtering/models/BaseFilter";
import type { IFilterPanelBaseFilterDeps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filters";
import type { FilterValueDelta } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/misc";
import { calculateArrayDelta } from "app/pages/sales-intelligence/modules/advanced-search-filtering/utils/calculateValueDeltaUtils";

import { mapArrayValues } from "../../utils/mapArrayValues";

import { TO_API, FROM_API } from "./const";

export default class FindAudienceGenderFilter extends FilterPanelBaseFilter<
    readonly AudienceGender[],
    readonly AudienceGender[]
> {
    constructor(deps: IFilterPanelBaseFilterDeps<readonly AudienceGender[], readonly AudienceGender[]>) {
        super({
            ...deps,
            options: deps.options.filter((id) => {
                return id !== AudienceGender.Female_60_80 && id !== AudienceGender.Male_60_80;
            }),
        });
    }

    toApiValue(value: readonly AudienceGender[] | undefined): readonly AudienceGender[] | undefined {
        return mapArrayValues(value, TO_API, true);
    }

    fromApiValue(apiValue: readonly AudienceGender[] | undefined): readonly AudienceGender[] | undefined {
        return mapArrayValues(apiValue, FROM_API, false);
    }

    calculateValueDelta = (
        previousValue?: readonly AudienceGender[],
        newValue?: readonly AudienceGender[],
    ): FilterValueDelta<AudienceGender> => {
        return calculateArrayDelta(previousValue, newValue);
    };
}
